import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import { Flex, Box, Container } from 'components/Grid';
import H2 from 'components/H2';
import ProjectGridItem from 'components/ProjectGridItem';
import Image from 'components/Image';
import gridSettings from 'utils/styles/customGridSettings';
import usePagination from 'utils/hooks/usePagination';
import chunk from 'utils/helpers/chunk';
import getSeo from 'utils/helpers/getSeo';


const CasePage = ({ data }) => {
	const { currentPage, handleSetPage, pageCount, items } = usePagination(data.case.edges, 5);
	const seo = getSeo(data.page);
	
	console.log(seo);

	const smallGridItems = ['i6', 'i7', 'i8'];
	const gridItemsChunked = chunk(items, 8); 

	return (
		<>
			<SEO {...seo} keywords={[`case`, `projekt`, `portfolio`]} />
			<Container large pt={0}>
				{gridItemsChunked &&
					gridItemsChunked.map((chunk, key) => {
						return (
							<Flex key={key} grid {...gridSettings}>
								{chunk &&
									chunk.map((item, i) => (
										<ProjectGridItem
											key={i}
											item={item.node}
											gridColumn={gridSettings.default}
											gridArea={['unset', `i${i + 1}`]}
											aspectRatio={smallGridItems.includes(`i${i + 1}`) ? 0.5 : 1}
										/>
									))}
							</Flex>
						);
					})}
			</Container>
			{currentPage < pageCount && (
				<Container pt={[0, 0]} pb={[5, 5, 7]} cursor="hourglass" onClick={handleSetPage}>
					<Flex alignItems="center" justifyContent="center">
						<Box textAlign="center">
							<H2 mb={0} color="client.primary">
								Ladda fler case
							</H2>
						</Box>
					</Flex>
				</Container>
			)}
			<Flex bg="client.accent" color="white">
				<Container>
					<Flex mb={[5]}>
						<Box>
							<H2 textAlign="center" color="client.fontColor">
								{data.page.clientsTitle}
							</H2>
						</Box>
					</Flex>
					<Flex grid gridGap={[4, 4]} gridTemplateColumns={['repeat(2, 1fr)', 'repeat(4, 1fr)']}>
						{data.page.clients.map((item, key) => (
							<Box display="flex" alignItems="center" justifyContent="center" key={key}>
								<Image
									style={{
										filter: 'grayscale(100%)'
									}}
									fadeIn={false}
									fixed={item.fixed}
								/>
							</Box>
						))}
					</Flex>
				</Container>
			</Flex>
		</>
	);
};

export const query = graphql`
	query {
		case: allContentfulCase(sort: { fields: [order], order: ASC }) {
			edges {
				node {
					id
					type: __typename
					darkText
					featuredImage {
						file {
							contentType
							url
						}
						fluid(quality: 100, maxWidth: 1600) {
							...GatsbyContentfulFluid
						}
					}
					headline
					slug
				}
			}
		}
		page: contentfulPageCase {
			seo {
				ogText
				ogDescription
				ogImage {
					file {
						url
					}
				}
			}
			clientsTitle
			clients {
				id
				fixed(width: 180) {
					...GatsbyContentfulFixed
				}
			}
		}
	}
`;

export default CasePage;
